<template>
  <div
    class="alert bg-danger radius-small font-md font-weight-600 clr-white py-1 px-2 flex-center shadow-type-5">
    <span>{{ message }}</span>
  </div>
</template>

<script>
  export default {
    name: 'ScanAlert',
    props: {
      message: {
        type: String,
        required: true
      },
    },
  }
</script>
